// extracted by mini-css-extract-plugin
module.exports = {"invites":"invites_invites__8MWoa","other":"invites_other__cEA_O","revoke":"invites_revoke__I1DMV","invite":"invites_invite__CPTpM"};